<template>
  <v-dialog
    v-model="internalDialog"
    max-width="1200"
    transition="dialog-transition"
    persistent
  >
    <v-card>
      <v-card-actions class="justify-end">
        <v-icon
          text
          @click="closeModal"
        >
          mdi-close-thick
        </v-icon>
      </v-card-actions>
      <v-toolbar
        dark
        style="background-color:rgb(204 33 40);color:white !important"
      >
        Detalle de Factura Electrónica [ {{ invoiceItem ? invoiceItem.prefix + '-' + invoiceItem.consecutive : '' }} ]
      </v-toolbar>
      <v-card-text>
        <v-row
          v-if="progress == true"
          align-content="center"
          class="fill-height"
          justify="center"
        >
          <v-col cols="6">
            <v-col
              class="text-subtitle-1 text-center"
              cols="12"
            >
              Consultando detalles de la factura
            </v-col>
            <v-progress-linear
              color="red darken-4"
              height="6"
              indeterminate
              rounded
            />
          </v-col>
        </v-row>
        <div v-else-if="!progress && listInvoiceDetail.length > 0">
          <v-stepper>
            <v-stepper-header>
              <v-stepper-step
                :complete="isPendienteComplete"
                step="1"
                color="green"
              >
                PENDIENTE
              </v-stepper-step>
              
              <v-divider :style="{ backgroundColor: isRecibidaComplete ? '#4CAF50' : '#615f5f', height: '2px' }" />

              <v-stepper-step
                :complete="isRecibidaComplete"
                step="2"
                color="green"
              >
                RECIBIDA
              </v-stepper-step>

              <v-divider :style="{ backgroundColor: isAutorizadoComplete ? '#4CAF50' : '#615f5f', height: '2px' }" />

              <v-stepper-step
                :complete="isAutorizadoComplete"
                step="3"
                color="green"
              >
                AUTORIZADO
              </v-stepper-step>

              <v-divider :style="{ backgroundColor: isNotificadoComplete ? '#4CAF50' : '#615f5f', height: '2px' }" />

              <v-stepper-step
                :complete="isNotificadoComplete"
                step="4"
                color="green"
              >
                NOTIFICADA
              </v-stepper-step>
            </v-stepper-header>
          </v-stepper>
          <br>

          <v-data-table
            :footer-props="{
              'items-per-page-text': 'filas por pagina',
            }"
            :headers="headers"
            :items="listInvoiceDetail"
            class="elevation-1"
          >
            <template v-slot:[`item.status`]="{ item }">
              <v-tooltip
                v-if="item.status === 'PCF'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="orange darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-clock
                  </v-icon>
                </template>
                <span>PENDIENTE CAMBIO DE FECHA</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'P'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="orange darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-send
                  </v-icon>
                </template>
                <span>PENDIENTE</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'RECIBIDA'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="blue darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-document-check
                  </v-icon>
                </template>
                <span>RECIBIDA</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'AUTORIZADO'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="green darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-check
                  </v-icon>
                </template>
                <span>AUTORIZADO</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'NOTIFICADO'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="green darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-email-check
                  </v-icon>
                </template>
                <span>NOTIFICADO</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'NO_AUTORIZADO'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="red darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-document-remove
                  </v-icon>
                </template>
                <span>NO AUTORIZADO</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'NO_NOTIFICADO'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="red darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-email-remove
                  </v-icon>
                </template>
                <span>NO NOTIFICADO</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="item.status === 'DEVUELTA'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="red darken-4"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-file-undo
                  </v-icon>
                </template>
                <span>DEVUELTA</span>
              </v-tooltip>
              <v-tooltip
                v-else
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="grey darken-2"
                    right
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span>{{ item.status }}</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.message`]="{ item }">
              <v-dialog
                transition="dialog-bottom-transition"
                max-width="700"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="cursor: pointer"
                    color="success darken-4"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-cloud-braces
                  </v-icon>
                </template>
                <template v-slot:default="dialog">
                  <v-card>
                    <v-toolbar
                      style="background-color:rgb(204 33 40);color:white !important"
                      dark
                    >
                      Mensaje de respuesta - Factura - {{ item.document_consecutive }}
                    </v-toolbar>
                    <v-card-text>
                      <div class="text-h6">
                        <json-viewer
                          :value="JSON.parse(item.message)"
                          copyable="true"
                          preview-mode="true"
                        >
                          <template v-slot:copy>
                            Copiar
                            <v-icon
                              style="cursor: pointer"
                              color="info darken-3"
                              class="mr-2"
                            >
                              mdi-content-copy
                            </v-icon>
                          </template>
                        </json-viewer>
                      </div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                      <v-btn
                        text
                        @click="dialog.value = false"
                      >
                        Cerrar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
            </template>
            <template v-slot:[`item.json`]="{ item }">
              <v-dialog
                transition="dialog-bottom-transition"
                max-width="700"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="cursor: pointer"
                    color="success darken-4"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-code-json
                  </v-icon>
                </template>
                <template v-slot:default="dialog">
                  <v-card>
                    <v-toolbar
                      style="background-color:rgb(204 33 40);color:white !important"
                      dark
                    >
                      Json enviado a SRI - Factura - {{ item.document_consecutive }}
                    </v-toolbar>
                    <v-card-text>
                      <div class="text-h6">
                        <json-viewer
                          :value="JSON.parse(item.json)"
                          copyable="true"
                        >
                          <template v-slot:copy>
                            Copiar
                            <v-icon
                              style="cursor: pointer"
                              color="info darken-3"
                              class="mr-2"
                            >
                              mdi-content-copy
                            </v-icon>
                          </template>
                        </json-viewer>
                      </div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                      <v-btn
                        text
                        @click="dialog.value = false"
                      >
                        Cerrar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
            </template>
            <template v-slot:[`item.url_xml_origen`]="{ item }">
              <v-icon
                v-if="item.status !== 'P' && item.status !== 'PCF'"
                class="mr-2"
                color="brown darken-3"
                style="cursor: pointer"
                @click="getDataFile(item.url_xml_origen, 'UrlXMLHiopos [' + item.document_consecutive + ']')"
              >
                mdi-folder-zip
              </v-icon>
            </template>
          </v-data-table>
        </div>
        <div v-else-if="!progress">
          <v-alert text type="info">
            No se encontraron detalles para esta factura.
          </v-alert>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { columnsRolesDetail } from '@/data/columnsRoles'

export default {
  name: 'InvoiceDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    invoiceItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      progress: false,
      headers: columnsRolesDetail,
      stateOrder: ['P', 'RECIBIDA', 'AUTORIZADO', 'NOTIFICADO'],
    }
  },
  computed: {
    internalDialog: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.closeModal()
        }
      }
    },
    currentStateIndex() {
      if (!this.listInvoiceDetail || this.listInvoiceDetail.length === 0) return -1

      // Buscar el estado más avanzado en el proceso
      let maxIndex = -1
      this.listInvoiceDetail.forEach(item => {
        const index = this.stateOrder.indexOf(item.status)
        if (index > maxIndex) {
          maxIndex = index
        }
      })

      return maxIndex
    },
    isPendienteComplete() {
      return this.currentStateIndex >= 0
    },
    isRecibidaComplete() {
      return this.currentStateIndex >= 1
    },
    isAutorizadoComplete() {
      return this.currentStateIndex >= 2
    },
    isNotificadoComplete() {
      return this.currentStateIndex >= 3
    },
    ...mapState('invoice', ['listInvoiceDetail', 'fileBase64', 'fileName'])
  },
  watch: {
    visible(newVal) {
      if (newVal && this.invoiceItem.prefix && this.invoiceItem.consecutive) {
        this.progress = true
        this.$store.commit('invoice/setListInvoiceDetail', [])
        this.loadInvoiceDetail()
      }
    },
    fileBase64() {
      // Solo descargar si el modal está visible y no es PDF
      if (this.visible && this.fileName !== 'PDF') {
        this.downloadFile(this.fileName)
      }
    },
    listInvoiceDetail(newVal) {
      if (newVal && newVal.length > 0) {
        this.progress = false
      }
    }
  },
  methods: {
    loadInvoiceDetail() {
      this.$store.dispatch('invoice/getListInvoiceDetail', {
        IdCompania: this.invoiceItem.company_id,
        Prefijo: this.invoiceItem.prefix,
        Consecutivo: this.invoiceItem.consecutive
      })
    },
    async getDataFile(file, name) {
      const datos = { url: file, nameFile: name }
      await this.$store.dispatch('invoice/getDataFile', datos)
    },
    downloadFile(name) {
      const linkSource = 'data:application/zip;base64,' + this.fileBase64.Datos
      const downloadLink = document.createElement('a')
      const fileName = name + '.zip'
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    closeModal() {
      this.progress = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
</style>